import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
const DOT_CLASSES = {
    neutral: 'bg-muted-foreground',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-destructive',
    info: 'bg-info',
};
/**
 * Status label with a colored dot — for system/component status ("Operational",
 * "Degraded"). The dot carries the color; the text stays at foreground contrast.
 */
export const StatusPill = forwardRef(({ className, tone = 'neutral', pulse = false, children, ...props }, ref) => (_jsxs("span", { ref: ref, className: cn('inline-flex items-center gap-2 text-sm font-medium text-foreground', className), ...props, children: [_jsxs("span", { className: "relative inline-flex size-2.5 shrink-0", "aria-hidden": "true", children: [pulse && (_jsx("span", { className: cn('absolute inline-flex h-full w-full animate-ping rounded-full opacity-60 motion-reduce:hidden', DOT_CLASSES[tone]) })), _jsx("span", { className: cn('relative inline-flex size-2.5 rounded-full', DOT_CLASSES[tone]) })] }), children] })));
StatusPill.displayName = 'StatusPill';
